import React, { useState } from 'react';
import { faStickyNote } from '@fortawesome/free-solid-svg-icons';
import {
  NoteEditorForm,
  NoteFormGroup,
  NoteLabel,
  NoteLabelIcon,
  NoteLabelText,
  NoteTextarea,
  NoteCharCount,
} from './FoodNoteForm.styled';

const FoodNoteForm = ({
  foodName = 'cet aliment',
  initialNote = '',
  onSubmit,
  isMobileViewport = false,
}) => {
  const [noteText, setNoteText] = useState(initialNote || '');
  const [isFocused, setIsFocused] = useState(false);

  const safeFoodName = (foodName || 'cet aliment').trim();

  const handleSubmit = (event) => {
    event.preventDefault();
    onSubmit(noteText);
  };

  const isNearLimit = noteText.length >= 450;
  const textareaRows = isMobileViewport ? 4 : 5;
  const shouldAutoFocusTextarea = !isMobileViewport;

  return (
    <NoteEditorForm id="note-editor-form" onSubmit={handleSubmit}>
      <NoteFormGroup>
        <NoteLabel htmlFor="note-textarea">
          <NoteLabelIcon icon={faStickyNote} />
          <NoteLabelText>
            Note pour &quot;{safeFoodName}&quot;
          </NoteLabelText>
        </NoteLabel>
        <NoteTextarea
          id="note-textarea"
          value={noteText}
          onChange={(event) => setNoteText(event.target.value)}
          placeholder="Ajoutez une note personnelle (ex: Bio, portion enfant, préférence...)"
          rows={textareaRows}
          maxLength={500}
          $isFocused={isFocused}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          autoFocus={shouldAutoFocusTextarea}
        />
        {noteText && (
          <NoteCharCount $isNearLimit={isNearLimit}>
            {noteText.length}/500 caractères
          </NoteCharCount>
        )}
      </NoteFormGroup>
    </NoteEditorForm>
  );
};

export default FoodNoteForm;
